// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-table {
  width: 100%;
  background: white;
  border-collapse: collapse;
  border-radius: 6px;
  overflow: hidden;
}

.data-table th {
  background: #f9fafb;
  text-align: left;
  padding: 12px;
  border-bottom: 1px solid #e5e7eb;
}

.data-table td {
  padding: 12px;
  border-bottom: 1px solid #e5e7eb;
}
`, "",{"version":3,"sources":["webpack://./src/styles/table.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC","sourcesContent":[".data-table {\n  width: 100%;\n  background: white;\n  border-collapse: collapse;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.data-table th {\n  background: #f9fafb;\n  text-align: left;\n  padding: 12px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.data-table td {\n  padding: 12px;\n  border-bottom: 1px solid #e5e7eb;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
